<template>
  <pagefra>
    <div class="malfunctions container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.deviceNo"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('主故障码')">
              <el-input
                v-model="form.mainFaultCode"
                :placeholder="$l('主故障码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('副故障码')">
              <el-input
                v-model="form.subFaultCode"
                :placeholder="$l('副故障码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('故障时间范围')">
              <el-date-picker
                v-model="faultTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('故障开始时间')"
                :end-placeholder="$l('故障结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('S.N.')"
              width="80"
              align="center"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('RMS SO record ID')"
              prop="id"
              align="center"
              min-width="120"
            ></el-table-column> -->
            <el-table-column
              :label="$l('EQ No.')"
              prop="deviceNo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Master TCD Code')"
              prop="mainFaultCode"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Slave TCD Code')"
              prop="subFaultCode"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Call Detail')"
              prop="description"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Receive Date&Time')"
              prop="malfunctionDate"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('First 5 Minutes')"
              prop="first5Minutes"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('Mantrap')"
              prop="isMantrap"
              align="center"
              width="120"
              :formatter="mantrapFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('BD Job Number')"
              prop="bdjobNumber"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('BD Matter status')"
              prop="bdmatterStatus"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('BD Report status')"
              prop="bdreportStatus"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Arrived Time')"
              prop="arriveDate"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Completed Time')"
              prop="finishDate"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Condition On Arrival')"
              prop="arrivalCondition"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Cause Detail')"
              prop="causeDetail"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Action Taken')"
              prop="actionTaken"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Condition')"
              prop="condition"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Cause')"
              prop="cause"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Action')"
              prop="action"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Responsible For')"
              prop="responsibleFor"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('FE')"
              prop="fe"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('CancelFlag')"
              prop="cancelFlag"
              align="center"
              width="120"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "malfunctions",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        deviceNo: "",
        mainFaultCode: "",
        subFaultCode: "",
        startMalfunctionTime: "",
        endMalfunctionTime: "",
      },
      tableData: [],
      loading: false,
      faultTimeValues: [],
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.faultTimeValues && this.faultTimeValues.length == 2) {
        this.form.startMalfunctionTime = this.$common.formatDateTime(
          this.faultTimeValues[0]
        );
        this.form.endMalfunctionTime = this.$common.formatDateTime(
          this.faultTimeValues[1]
        );
      } else {
        this.form.startMalfunctionTime = null;
        this.form.endMalfunctionTime = null;
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_malfunctions_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    mantrapFormatter(row) {
      if (row.isMantrap == 0) {
        return this.$l("不困人");
      } else if (row.isMantrap == 1) {
        return this.$l("困人");
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.malfunctions {
}
</style>
